import React from "react";

const CASNavbar = ({ setActivePage, activePage }) => {
  const pages = ["Indent Report", "Loading","Unloading"];
  const handleBtnClick = (btnName) => {
    setActivePage(btnName);
  };
  return (
    <div className="newUiBody">
      {pages.map((button, index) => {
        return (
          <button
            key={index}
            className={`btn btn-outline-dark m-1 ${
              activePage === button && "active"
            }`}
            onClick={() => {
              handleBtnClick(button);
            }}
          >
            {button}
          </button>
        );
      })}
    </div>
  );
};

export default CASNavbar;
